import { render, staticRenderFns } from "./ActivityGoodsCard.vue?vue&type=template&id=15bce7aa&scoped=true"
import script from "./ActivityGoodsCard.vue?vue&type=script&lang=ts"
export * from "./ActivityGoodsCard.vue?vue&type=script&lang=ts"
import style0 from "./ActivityGoodsCard.vue?vue&type=style&index=0&id=15bce7aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bce7aa",
  null
  
)

export default component.exports